'use strict';
const { queryFirst, addClass, removeClass, throttle, hasClass, setAttribute, queryAll, loadInput, validateDate } = require('../domUtil');
const formValidation = require('base/components/formValidation');
const { getTimeRemaining, getItemFromLocalStorage, formatPhoneNumber, getJSON } = require('../util');
const { resetPassword } = require('../login/login');
const { MY_ACCOUNT } = require('../components/shippingPreference/constants');
const $body = $('body');
const hiddenClass = 'd-none';
const loyaltyWelcomeDialog = queryFirst('.loyalty-welcome-popup');
const loyaltyEnrollNowDialog = queryFirst('#loyalty-enrollnow-modal');
const invalidClass = 'is-invalid';
const desktopShowClass = 'desktop-show';
const activeClass = 'active';
const exclusiveCarouselIdSelector = '#exclusive-experience-carousel';
let mobileImg, desktopImg;
const root = document.documentElement;
const { initSpecificCarousel } = require('../components/carousel');
const loyaltyEarlyAccessRegisterForm = queryFirst('#loyalty-early-access-register');
const earlyAccessPdpSignInRegistration = queryAll('.js-early-access-sign-in-cta');
const { ajaxFormInvalid, ajaxFormSubmit, enableFormSubmitButton, invalid } = require('../clientSideValidation');
const swatchImageDownload = queryFirst('.swatch-image-download');
const swatchImageDownloaded = queryFirst('.swatch-image-downloaded');
const downloadCtaDesktop = '.download-cta.desktop-show';
const downloadCtaMobile = '.download-cta.mobile-show';

$body.on('hidden.bs.modal', function () {
    if (!queryFirst('.modal.show')) {
        $body.removeClass('referral-modal');
    }
});

/**
 * Handle the enroll now popup view
 */
function handleEarlyAccessEnrollModal() {
    $(loyaltyEnrollNowDialog).modal('show').off('hidden.bs.modal').on('hidden.bs.modal', function () {
        const welcomeDialogEarlyAccessMsgEl = queryFirst('.js-loyalty-welcome-early-access-msg');
        const welcomeDialogMsgEl = queryFirst('.js-loyalty-welcome-msg');
        if (!hasClass(loyaltyWelcomeDialog, 'show')) {
            location.reload();
        } else {
            addClass(welcomeDialogMsgEl, hiddenClass);
            removeClass(welcomeDialogEarlyAccessMsgEl, hiddenClass);
            removeWelcomeModalShowSession();
        }
    });
    $(loyaltyWelcomeDialog).off('hidden.bs.modal').on('hidden.bs.modal', function (e) {
        location.reload();
    });
}

/**
 * Login form on PDP Early Access
 * @param {boolean} isLoyaltyMember - if the user is enrolled to loyalty or not
 * @param {string} postalCode - ZIP Code
 * @param {string} showWelcomeModal - When the enrollment is complete and the welcome modal needs to be displayed, it will be true
 */
function handlePdpEarlyAccessLoginRegistration(isLoyaltyMember, postalCode, showWelcomeModal) {
    if (showWelcomeModal) {
        $(loyaltyWelcomeDialog).modal('show').off('hidden.bs.modal').on('hidden.bs.modal', function (e) {
            location.reload();
        });
        removeWelcomeModalShowSession();
    } else if (isLoyaltyMember) {
        location.reload();
    } else {
        const loyaltyEnrollModalForm = queryFirst('.loyalty-get-access');
        const loyaltyEnrollPostalCodeEl = queryFirst('.js-loyalty-access-postal-code', loyaltyEnrollModalForm);
        const loyaltyGuestEnrollment = queryFirst('.loyalty-getaccess-section .guest-enrollment');
        addClass(loyaltyGuestEnrollment, hiddenClass);
        removeClass(loyaltyEnrollModalForm, hiddenClass);
        if (!postalCode) {
            removeClass(loyaltyEnrollPostalCodeEl, hiddenClass);
        } else {
            queryFirst('.loyalty-access-form-postalcode', loyaltyEnrollPostalCodeEl).value = postalCode;
        }
        handleEarlyAccessEnrollModal();
    }
}
/**
 * Login form on PDP Early Access
 * @param {Object} form - form element
 */
function earlyAccessSignIn(form) {
    const url = form.attr('action');
    $.spinner().start();
    $.ajax({
        url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            $.spinner().stop();
            if (!data.success) {
                formValidation(form, data);
                form.trigger('login:error', data);
            } else {
                const { loyaltyProgramMemberId, postalCode } = data;
                $(loyaltyEarlyAccessRegisterForm).modal('hide');
                handlePdpEarlyAccessLoginRegistration(!!loyaltyProgramMemberId, postalCode);
            }
        },
        error: function () {
            $.spinner().stop();
            $(loyaltyEarlyAccessRegisterForm).modal('hide');
        }
    });
}
/**
 * Remove show modal session attribute on close of welcome modal
 */
function removeWelcomeModalShowSession() {
    const closeButton = queryFirst('.loyalty-welcome-popup .close-welcome-modal');
    getJSON(closeButton.dataset.welcomeSessionUrl, 'get');
}
/**
 * Registration form on PDP Early Access
 * @param {Object} form - form element
 */
function earlyAccessRegistration(form) {
    const url = form.attr('action');
    $.spinner().start();
    $.ajax({
        url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
            $.spinner().stop();
            if (data.success) {
                const { optedInToLoyalty, postalCode } = data;
                const showWelcomeModal = optedInToLoyalty;
                $(loyaltyEarlyAccessRegisterForm).modal('hide');
                handlePdpEarlyAccessLoginRegistration(optedInToLoyalty, postalCode, showWelcomeModal);
            } else {
                formValidation(form, data);
                form.trigger('register:error');
            }
        },
        error: function () {
            $.spinner().stop();
            $(loyaltyEarlyAccessRegisterForm).modal('hide');
        }
    });
}
/**
 * Function to attach form validation events
 * @param {Object} form - form element
 */
function attachLoginRegistrationFormEvents(form) {
    ajaxFormInvalid(form);
    ajaxFormSubmit(form);
    enableFormSubmitButton();
}

/**
 * Function to handle early access sign in or registration on PLP and PDP page
 * @param {Object} earlyAccessCta - element
 */
function handleEarlyAccessLogin(earlyAccessCta) {
    if (earlyAccessCta) {
        const { actionUrl } = earlyAccessCta.dataset;
        $.spinner().start();
        $.ajax({
            url: actionUrl,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.success) {
                    $(loyaltyEarlyAccessRegisterForm).modal('show');
                    const { accountRegistrationForm, loginForm } = data;
                    const signInForm = queryFirst('.early-access-login-form');
                    const registerForm = queryFirst('.early-access-register-form');
                    signInForm.innerHTML = loginForm;
                    registerForm.innerHTML = accountRegistrationForm;
                    const accountHelpEl = queryFirst('.account-need-help');
                    const earlyAccessRegisterLeft = queryFirst('.registration-left');
                    const earlyAccessRegisterRight = queryFirst('.registration-right');
                    addClass(accountHelpEl, hiddenClass);
                    addClass([earlyAccessRegisterLeft, earlyAccessRegisterRight], 'col-md-6');
                    const loyaltyRegistrationForm = '.early-access-register-form form.registration';
                    const loyaltyLoginForm = '.early-access-login-form form.login';
                    resetPassword();
                    invalid();
                    attachLoginRegistrationFormEvents(loyaltyLoginForm);
                    attachLoginRegistrationFormEvents(loyaltyRegistrationForm);
                    const registrationFormPhone = queryFirst('.registration-form-phone', earlyAccessRegisterLeft);
                    formatPhoneNumber(registrationFormPhone);
                    validateDate();
                    $(loyaltyLoginForm).off('submit').on('submit', function (e) {
                        const form = $(this);
                        e.preventDefault();
                        earlyAccessSignIn(form);
                    });
                    $(loyaltyRegistrationForm).off('submit').on('submit', function (e) {
                        const form = $(this);
                        e.preventDefault();
                        earlyAccessRegistration(form);
                    });
                }
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * hide or show drawer image in mobile and desktop view
 * @param {string} drawerMobileImg - image for mobile view
 * @param {string} drawerDesktopImg - image for desktop view
 */
function hideShowDrawerImage(drawerMobileImg, drawerDesktopImg) {
    const desktopImageWrapper = queryFirst('.drawer-img-wrap-desktop');
    const mobileImageWrapper = queryFirst('.drawer-img-wrap-mobile');
    const drawerMobileImgEl = queryFirst('.drawer-image-mobile');
    const drawerDesktopImgEl = queryFirst('.drawer-image-desktop');

    // check if scene7 link is present for mobile or desktop or both
    if (drawerMobileImg !== 'null' && drawerMobileImgEl) {
        drawerMobileImgEl.src = drawerMobileImg;
    }

    loyaltyDrawerImageView(drawerMobileImg, mobileImageWrapper);

    if (drawerDesktopImg !== 'null' && drawerDesktopImgEl) {
        drawerDesktopImgEl.src = drawerDesktopImg;
    }

    loyaltyDrawerImageView(drawerDesktopImg, desktopImageWrapper);
}

/**
 * update the backgroud of referral section bassed on the configuration in content asset
 */
function updateReferralBg() {
    const loyaltyReferralBg = queryFirst('.referral-section-bg-color');
    if (!loyaltyReferralBg) {
        return;
    }
    const { bgColor, bgImageDesktop, bgImageMobile } = loyaltyReferralBg.dataset;
    if (bgImageDesktop) {
        root.style.setProperty('--referral-bg-img-desktop', `url(${bgImageDesktop})`);
    }
    if (bgImageMobile) {
        root.style.setProperty('--referral-bg-img-mobile', `url(${bgImageMobile})`);
    }
    if (bgColor) {
        root.style.setProperty('--referral-bg-color', bgColor);
    }
}


/**
 * handling hide or show of drawer image and background color in mobile and desktop view
 * @param {string} image - image of mobile/desktop view
 * @param {string} el - wrapper element of desktop/mobile
 */
function loyaltyDrawerImageView(drawerImage, el) {
    const loyaltyModalEl = queryFirst('#loyalty-program-modal .modal-content');
    const withImageEl = queryFirst('.drawer-with-img', el);
    const withoutImageEl = queryFirst('.drawer-without-img', el);
    const loyaltyDrawerBackground = 'loyalty-background';

    if (drawerImage && drawerImage !== 'null') {
        addClass(withoutImageEl, hiddenClass);
        removeClass(withImageEl, hiddenClass);
        addClass(loyaltyModalEl, loyaltyDrawerBackground);
    } else {
        removeClass(withoutImageEl, hiddenClass);
        addClass(withImageEl, hiddenClass);
        addClass(loyaltyModalEl, loyaltyDrawerBackground);
    }

}

/**
 * show how to earn drawer image in mobile and desktop view
 * @param {string} drawerMobileImg - image for mobile view
 * @param {string} drawerDesktopImg - image for desktop view
 * @param {string} drawerTitle - title for the drawer
 * @param {string} drawerCloseButtonLabel - close button label
 */
function showHowToEarnDrawerImage(drawerMobileImg, drawerDesktopImg, drawerTitle, drawerCloseButtonLabel) {
    const drawerMobileImgEl = queryFirst('.drawer-image-mobile');
    const drawerDesktopImgEl = queryFirst('.drawer-image-desktop');
    const drawerTitleE1 = queryFirst('#loyalty-how-to-earn-modal-label');
    const drawerCloseButtonE1 = queryFirst('#loyalty-how-to-earn-modal .close-current-modal');

    if (drawerTitle && drawerTitleE1) {
        drawerTitleE1.innerHTML = drawerTitle;
    }
    if (drawerCloseButtonLabel && drawerCloseButtonE1) {
        drawerCloseButtonE1.ariaLabel = drawerCloseButtonLabel;
    }
    if (drawerMobileImg !== 'null' && drawerMobileImgEl) {
        drawerMobileImgEl.src = drawerMobileImg;
    }
    if (drawerDesktopImg !== 'null' && drawerDesktopImgEl) {
        drawerDesktopImgEl.src = drawerDesktopImg;
    }
}
/**
 * Add the image URL in download CTA on select of wallpaper swatch
 * @param {HTMLElement} selectedWallpaperId - selected swatch element Id
 */
function updateImgURLOnDownloadCta(selectedWallpaperId) {
    const selectTab = selectedWallpaperId ? queryFirst(selectedWallpaperId) : queryFirst('.main-swatch-section .tab-pane.active');
    const imageElement = queryFirst('.wallpaper-main-image', selectTab);
    const swatchImageDownloadCtaDesktop = queryFirst(downloadCtaDesktop, swatchImageDownload);
    const swatchImageDownloadCtaMobile = queryFirst(downloadCtaMobile, swatchImageDownload);
    const swatchImageDownloadedCtaDesktop = queryFirst(downloadCtaDesktop, swatchImageDownloaded);
    const swatchImageDownloadedCtaMobile = queryFirst(downloadCtaMobile, swatchImageDownloaded);
    if (imageElement) {
        const { desktopDownloadedImage, mobileDownloadedImage } = imageElement.dataset;
        setAttribute(swatchImageDownloadCtaDesktop, 'href', desktopDownloadedImage);
        setAttribute(swatchImageDownloadCtaMobile, 'href', mobileDownloadedImage);
        setAttribute(swatchImageDownloadedCtaDesktop, 'href', desktopDownloadedImage);
        setAttribute(swatchImageDownloadedCtaMobile, 'href', mobileDownloadedImage);
    }
}

/**
 * Add click event listener on download cta to call the update image URL function
 */
function loyaltySwatchImgDownload() {
    updateImgURLOnDownloadCta();
    $body.on('click', '.img-wallpaper', function (e) {
        const selectedWallpaperId = this.closest('a').hash;
        updateImgURLOnDownloadCta(selectedWallpaperId);
        addClass(swatchImageDownloaded, hiddenClass);
        removeClass(swatchImageDownload, hiddenClass);
    }); 

    $body.on('click', '.download-cta.desktop-show, .download-cta.mobile-show', function () {
        addClass(swatchImageDownload, hiddenClass);
        removeClass(swatchImageDownloaded, hiddenClass);
    });
}

/**
 * Updated the counter timmer in every second
 * @param {string} countDataMsg - timmer string
 * @param {string} countDownTime - countDownTimmer
 * @param {HTMLElement} countDownEle - Html element where the timer needs to updated
 * @param {Object} timeinterval - OOS javascript function updated on every second
 */
function updateClock(countDataMsg, countDownTime, countDownEle, timeinterval, countDataMsgNoDays) {
    const { tokenize } = require('../util');
    const timer = getTimeRemaining(countDownTime);
    const newCountDataMsg = (timer.days === 0) ? countDataMsgNoDays : countDataMsg;
    countDownEle.innerHTML = tokenize(newCountDataMsg, timer, '[', ']');
    if (timer.total <= 0) {
        clearInterval(timeinterval);
    }
}


/**
 * Updated voucher Expiry date to formatted string
 * @param {string} expiryDate - API response expiry date string
 * @param {string} formatString - format string of resource message
 * @return {string} formattedString - formatted expiry date string
 */
function getFormatDateString(expiryDate, formatString) {
    if (!expiryDate) {
        return expiryDate;
    }
    const expiryDateStringArray = expiryDate.split(' ');
    const formattedString = expiryDateStringArray[0] + ' ' + formatString;
    return formattedString;
}
/**
 * Add click event listener on download cta to call the update image URL function
 */
function exclusiveExperiencesCountDown() {
    const exclusiveExperiencesTile = queryAll('.exclusive-tile');
    if (exclusiveExperiencesTile.length > 0) {
        for (let i = 0, n = exclusiveExperiencesTile.length; i < n; i++) {
            const exclusiveModule = exclusiveExperiencesTile[i];
            const countDownTime = exclusiveModule.dataset.countDownTimer;
            const countDownEle = queryFirst('.count-down-timer', exclusiveModule);
            const countDownEleNoDays = queryFirst('.count-down-timer-nodays', exclusiveModule);
            const countDataMsg = countDownEle.dataset.counterMsg;
            const countDataMsgNoDays = countDownEleNoDays.dataset.counterMsg;
            if (countDownTime) {
                // update the counter
                const timeinterval = setInterval(function () { updateClock(countDataMsg, countDownTime, countDownEle, timeinterval, countDataMsgNoDays) }, 1000);
            } else {
                addClass(countDownEle, hiddenClass);
            }
        }
    }
}

/**
 * Hide show the right and left icon if carousel reaches to last or first position
 */
$(exclusiveCarouselIdSelector).carousel({
    wrap: false
});

const carouselControlsToggle = function () {
    const exclusiveCarousel = queryFirst(exclusiveCarouselIdSelector);

    if (exclusiveCarousel) {
        const parentElement = queryFirst('.image-slide-indicators', exclusiveCarousel);
        const carouselControl = queryFirst('.lp-icon-chevron', exclusiveCarousel);
        const { lastElementChild, firstElementChild } = parentElement;
        const previousControl = queryFirst('.carousel-control-prev', exclusiveCarousel);
        const nextControl = queryFirst('.carousel-control-next', exclusiveCarousel);
        if (hasClass(lastElementChild, activeClass)) {
            addClass(nextControl, hiddenClass);
            removeClass(previousControl, hiddenClass);
        } else if (hasClass(firstElementChild, activeClass)) {
            removeClass(nextControl, hiddenClass);
            addClass(previousControl, hiddenClass);
        } else {
            removeClass(carouselControl, hiddenClass);
        }
    }
};

window.addEventListener('load', (event) => {
    const formElement = queryFirst('.loyalty-get-access');
    const referrerID = getItemFromLocalStorage('REFERRED_ID');
    if (referrerID && formElement) {
        loadInput(referrerID, formElement);
    }
});

if (earlyAccessPdpSignInRegistration.length) {
    earlyAccessPdpSignInRegistration.forEach((earlyAccessBtn) => {
        earlyAccessBtn.addEventListener('click', e => {
            e.preventDefault();
            handleEarlyAccessLogin(earlyAccessBtn);
        });
    });
}

/**
 * Function to initialize events
 */
function init() {
    loyaltySwatchImgDownload();
    exclusiveExperiencesCountDown();
    carouselControlsToggle();
    $(exclusiveCarouselIdSelector).on('slid.bs.carousel', '', carouselControlsToggle);
}

module.exports = {
    loyaltyDrawer: function () {
        const loyaltyAppImage = queryFirst('.is-drawer-img');
        if (loyaltyAppImage) {
            const loyaltyDrawerContent = queryFirst('.loyalty-drawer-content');
            const { isAppDrawer } = loyaltyAppImage.dataset;
            const drawerAppImgEl = queryFirst('.drawer-image-mobile');
            if (isAppDrawer === "true") {
                mobileImg = loyaltyAppImage.dataset.mobileImg;
                const appImageWrapper = queryFirst('.drawer-img-wrap-mobile');
                if (mobileImg && mobileImg !== 'null') {
                    drawerAppImgEl.src = mobileImg;
                }
                const appMobileImgEl = queryFirst('body');
                addClass(appMobileImgEl, 'loyalty-background-ios');
                loyaltyDrawerImageView(mobileImg, appImageWrapper);
            }
            removeClass(loyaltyDrawerContent, hiddenClass);
        }

        $body.on('click', '.loyalty-program-drawer-link, .loyalty-program-terms-condition, .loyalty-how-to-earn-drawer-link', function (e) {
            e.preventDefault();
            const url = this.dataset.href;
            const isLoyaltyProgramDrawerClick = $(this).hasClass('loyalty-program-drawer-link');
            const isLoyaltyProgramOverviewFromHeader = $(this).hasClass('loyalty-program-overview-from-header');
            const isMobileSession = queryFirst('.mobile-session');
            if (isMobileSession) {
                return true;
            }
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'html',
                success: function (data) {
                    if (data) {
                        if (isLoyaltyProgramDrawerClick) {
                            const loyaltyContainer = queryFirst('.loyalty-drawer-body');
                            loyaltyContainer.innerHTML = data;
                            const loyaltyDrawerContent = queryFirst('.loyalty-drawer-content');
                            removeClass(loyaltyDrawerContent, hiddenClass);
                            const guestEnrollment = queryFirst('.lilly-loyalty-container .guest-enrollment');
                            const memberSignInEnrollment = queryFirst('.lilly-loyalty-container .already-registered-log-in');
                            if (guestEnrollment && memberSignInEnrollment) {
                                if (isLoyaltyProgramOverviewFromHeader) {
                                    removeClass([guestEnrollment, memberSignInEnrollment], hiddenClass);
                                } else {
                                    addClass([guestEnrollment, memberSignInEnrollment], hiddenClass);
                                }
                            }
                            const loyaltyIsImage = queryFirst('.is-drawer-img', loyaltyContainer);
                            desktopImg = loyaltyIsImage.dataset.desktopImg;
                            mobileImg = loyaltyIsImage.dataset.mobileImg;
                            hideShowDrawerImage(mobileImg, desktopImg);
                        } else {
                            const loyaltyContainer = queryFirst('.loyalty-how-to-earn-drawer-body');
                            loyaltyContainer.innerHTML = data;
                            const loyaltyIsImage = queryFirst('.is-how-to-earn-drawer-img', loyaltyContainer);
                            desktopImg = loyaltyIsImage.dataset.desktopImg;
                            mobileImg = loyaltyIsImage.dataset.mobileImg;
                            const title = loyaltyIsImage.dataset.title;
                            const closeButtonLabel = loyaltyIsImage.dataset.closeButton;
                            showHowToEarnDrawerImage(mobileImg, desktopImg, title, closeButtonLabel);
                        }
                        $.spinner().stop();
                    }
                },
                error: function (err) {
                    $.spinner().stop();
                }
            });
        })
    },
    loyaltyEnrollNowDialog: function () {
        $body.on('click', '.loyalty-enrollnow-cta', function (e) {
            e.preventDefault();
            $('#loyalty-enrollnow-modal').modal('show');
            const loyaltyEnrollPostalCodeContainer = queryFirst('.js-loyalty-access-postal-code');
            const loyaltyEnrollPostalEl = queryFirst('.loyalty-access-form-postalcode', loyaltyEnrollPostalCodeContainer);
            const loyaltyEnrollCheckboxEl = queryFirst('.optin-to-loyalty-program');
            const loyaltyEnrollNowEl = queryFirst('.loyalty-get-access');
            loyaltyEnrollNowEl.dataset.enrollNowSource = MY_ACCOUNT;
            const loyaltyRemoveClass = [];
            if (!hasClass(loyaltyEnrollPostalCodeContainer, hiddenClass)) {
                loyaltyRemoveClass.push(loyaltyEnrollPostalEl);
                loyaltyEnrollPostalEl.value = '';
            }
            if (loyaltyEnrollCheckboxEl) {
                loyaltyRemoveClass.push(loyaltyEnrollCheckboxEl);
                loyaltyEnrollCheckboxEl.checked = false;
            }
            removeClass(loyaltyRemoveClass, invalidClass);
        });
        $body.on('click', '.loyalty-early-access-welcome-cta', function (e) {
            location.reload();
        });
    },
    loyaltyEnrollNowSubmit: function () {
        $('form.loyalty-get-access').off('submit').on('submit', function (e) {
            e.preventDefault();
            const postalCodeEl = queryFirst('.loyalty-access-form-postalcode');
            const referrerIDEl = queryFirst('.referrerID');
            const postalCodeRegex = postalCodeEl ? new RegExp(postalCodeEl.dataset.regexp) : '';
            const postalCode = postalCodeEl ? postalCodeEl.value : '';
            const loyaltyEnrollNowEl = queryFirst('.loyalty-get-access');
            const source = loyaltyEnrollNowEl.dataset.enrollNowSource;
            const referrerID = referrerIDEl ? referrerIDEl.value : '';
            const invalidFeedback = queryFirst('#form-postalcode-error.invalid-feedback');
            if (postalCode && !postalCodeRegex.test(postalCode)) {
                if (invalidFeedback) {
                    addClass(postalCodeEl, invalidClass);
                    invalidFeedback.textContent = postalCodeEl.dataset.patternMismatch;
                }
            }
            else {
                $.spinner().start();
                let requestData = {
                    postalCode,
                    lillyLoyaltyProgram: true,
                    source
                };
                if (referrerIDEl) {
                    requestData = {
                        postalCode,
                        lillyLoyaltyProgram: true,
                        referrerID
                    };
                }
                const url = this.dataset.href;
                $.ajax({
                    url: url,
                    type: 'POST',
                    data: requestData,
                    dataType: 'html',
                    success: function (data) {
                        const responseData = JSON.parse(data);
                        if (responseData.success) {
                            $('#loyalty-enrollnow-modal').modal('hide');
                            $('#loyalty-welcome-popup').modal('show');
                        }
                        $.spinner().stop();
                    },
                    error: function (err) {
                        $.spinner().stop();
                    }
                });
            }

        });
        const loyaltyUnenrollDashboard = queryFirst('.loyalty-dashboard-unenroll');
        $(loyaltyWelcomeDialog).on('hidden.bs.modal', function () {
            if (loyaltyUnenrollDashboard) {
                location.reload();
            }
        });
        const accountLoyaltyDashboard = queryFirst('.account-lilly-loyalty');
        if (accountLoyaltyDashboard && accountLoyaltyDashboard.dataset.showWelcomePopup === 'true') {
            $('#loyalty-welcome-popup').modal('show');
            removeWelcomeModalShowSession();
        }
    },
    loyaltyDashboardShow: function () {
        $('.loyalty-dashboard-link').off('click').on('click', function (e) {
            e.preventDefault();
            const url = this.dataset.checkLoyaltyAccess;
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    if (!data) {
                        $.spinner().stop();
                        return false;
                    }
                    if (data.showEnrollmentModel) {
                        if (data.imageUrls) {
                            const modelImages = data.imageUrls;
                            const enrollmentModel = $('.loyalty-enroll-now-container');
                            const welcomeModel = $('.loyalty-welcome-popup');
                            enrollmentModel.find('.drawer-image-source').attr('srcset', modelImages.loyaltyaccesspopupmobile);
                            enrollmentModel.find('.drawer-image').attr('src', modelImages.LoyaltyguestenrollmentnonloyaltyD2x);
                            welcomeModel.find('.drawer-image-source').attr('srcset', modelImages.loyaltywelcomepopupmobile);
                            welcomeModel.find('.drawer-image').attr('src', modelImages.LoyaltywelcomeloyaltyD2x);
                            $('#loyalty-enrollnow-modal').modal('show');
                        }
                    } else {
                        window.location.href = data.redirectUrl;
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    loyaltyDashboardOffersTile: function () {
        const offerExpirationDateEl = queryAll('.offer-expiration-date');
        offerExpirationDateEl.forEach(el => {
            const expirationDateTime = el.textContent;
            el.textContent = expirationDateTime.split(' ')[0];
        });
        $body.on('click', '.flip-card-front', function (e) {
            e.preventDefault();
            const cardFlippedEl = this.closest('.offer-flip-card');
            const cardFront = queryFirst('.flip-card-front', cardFlippedEl);
            addClass(cardFlippedEl, 'offer-card-flipped');
            cardFront.style.pointerEvents = 'none';
        });
        $body.on('click', '.reveal-state-done', function (e) {
            e.preventDefault();
            const cardFlippedEl = this.closest('.offer-flip-card');
            const cardFront = queryFirst('.flip-card-front', cardFlippedEl);
            removeClass(cardFlippedEl, 'offer-card-flipped');
            cardFront.style.pointerEvents = 'unset';
        });
        $body.on('click', '.view-copy-code-cta', function (e) {
            e.preventDefault();
            const { target, expiryDate, couponCode, formatString } = e.target.dataset;
            const offerDiscountDialog = queryFirst(target);
            const offerDiscountTileData = queryFirst('.offer-tile-content', offerDiscountDialog);
            const offerDiscountModalData = queryFirst('.offer-code-modal-content', offerDiscountDialog);
            const copyCodeText = queryFirst('.copy-code-section .code-section', offerDiscountDialog);
            queryFirst('.coupon-expiry .expiry-date', offerDiscountDialog).textContent = getFormatDateString(expiryDate, formatString);
            copyCodeText.textContent = couponCode;
            addClass(offerDiscountTileData, hiddenClass);
            removeClass(offerDiscountModalData, hiddenClass);
            $(offerDiscountDialog).modal('show');
            copyCodeText.select();
            copyCodeText.setSelectionRange(0, 99999); /* For mobile devices */
            /* Copy the text */
            navigator.clipboard.writeText(copyCodeText.value);
        });
    },
    loyaltyReferralDrawer: function () {
        $body.on('click', '.loyalty-referral-drawer-link', function (e) {
            const referralUrlElement = queryFirst('.referral-drawer-link');
            $('.referral-link').val((referralUrlElement.dataset.referralUrl).replace('https://', ''));
            $body.addClass('referral-modal');
        });
    },
    loyaltyCopyReferralUrl: function () {
        $body.on('click', '.referral-cta-link', function (e) {
            const copyReferralUrl = queryFirst('.referral-link');
            const copyCta = queryFirst('.referral-cta-link');
            const copiedLinkCta = queryFirst('.copied-link');
            const referralUrlElement = queryFirst('.referral-drawer-link');
            copyReferralUrl.select();
            copyReferralUrl.setSelectionRange(0, 99999); /* For mobile devices */

            /* Copy the text */
            navigator.clipboard.writeText(referralUrlElement.dataset.referralUrl).then(function () {
                /* clipboard successfully set */
                addClass(copyCta, hiddenClass);
                removeClass(copiedLinkCta, hiddenClass);
                setTimeout(function () {
                    removeClass(copyCta, hiddenClass);
                    addClass(copiedLinkCta, hiddenClass);
                }, 3000);
            });
        });
    },
    loyaltyOopsRefreshSection: function (e) {
        $body.on('click', '.error-refresh-link', function (e) {
            e.preventDefault();
            const url = this.dataset.referralUrl;
            const successServiceResData = this.closest('.service-response-section');
            if (!successServiceResData) {
                location.reload();
            }
            const tooltipModule = queryFirst('.tool-tip-content', successServiceResData);
            const tooltipInnerData = queryFirst('.' + tooltipModule.id);
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    if (!data.error) {
                        if (successServiceResData) {
                            successServiceResData.innerHTML = data.serviceResHTMLData;
                            const updatedToolTip = queryFirst('.tool-tip-content', successServiceResData);
                            if (updatedToolTip && tooltipInnerData) {
                                updatedToolTip.innerHTML = tooltipInnerData.innerHTML;
                                const popContent = queryFirst('.loyalty-tooltip-popover', updatedToolTip);
                                const tooltipIcon = queryFirst('.loyalty-tooltip-icon', updatedToolTip);
                                $(tooltipIcon).popover({
                                    trigger: 'click',
                                    placement: 'auto',
                                    html: true,
                                    content: popContent
                                });
                                $('[data-toggle="popover"]').on('shown.bs.popover', function (e) {
                                    const { target } = e;
                                    $body.one('click', function (clickEvent) {
                                        const clicked = clickEvent.target;
                                        if (clicked !== target && clicked.parentElement !== target && $('.popover.show').length) {
                                            $(target).trigger('click');
                                        }
                                    });
                                });
                                const scrollableContent = queryFirst('.scrollable-content', successServiceResData);
                                if (scrollableContent) initSpecificCarousel(scrollableContent);
                            }
                            updateReferralBg();
                            init();
                        }
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    $.spinner().stop();
                }
            });
        });
    },
    referralModuleBg: function (e) {
        updateReferralBg();
        const referralSection = queryFirst('.referral-section-bg-color');
        removeClass(referralSection, hiddenClass);
    },
    loyaltyEarlyAccessSignUp: function () {
        $body.on('click', '.early-access-registered .early-access-sign-up', function (e) {
            e.preventDefault();
            handleEarlyAccessEnrollModal();
        });

        $body.on('click', '.early-access-register-form-cancel', function (e) {
            e.preventDefault();
            $(loyaltyEarlyAccessRegisterForm).modal('hide');
        });
    },
    init: init,
    handleEarlyAccessLogin: handleEarlyAccessLogin
};

window.addEventListener('resize', throttle(() => {
    if (mobileImg || desktopImg) {
        hideShowDrawerImage(mobileImg, desktopImg);
    }
    updateReferralBg();
}));
